(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[820],{

/***/ 5353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(3897);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _error; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(2918);
;// CONCATENATED MODULE: ./src/pages/_error.tsx




var MyError = function(param) {
    var statusCode = param.statusCode, hasGetInitialPropsRun = param.hasGetInitialPropsRun, err = param.err;
    if (!hasGetInitialPropsRun && err) {
    // getInitialProps is not called in case of
    // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured
    // Sentry.captureException(err);
    // Flushing is not required in this case as it only happens on the client
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
        statusCode: statusCode
    });
};
MyError.getInitialProps = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(context) {
        var errorInitialProps, res, err, asPath;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return error["default"].getInitialProps(context);
                case 2:
                    errorInitialProps = _ctx.sent;
                    res = context.res, err = context.err, asPath = context.asPath;
                    // Workaround for https://github.com/vercel/next.js/issues/8592, mark when
                    // getInitialProps has run
                    errorInitialProps.hasGetInitialPropsRun = true;
                    if (!((res === null || res === void 0 ? void 0 : res.statusCode) === 404)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", errorInitialProps);
                case 7:
                    if (!err) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", errorInitialProps);
                case 9:
                    return _ctx.abrupt("return", errorInitialProps);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _error = (MyError);


/***/ }),

/***/ 2918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(5353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);